export default __webpack_public_path__ + "static/dinnericon-42a48496a4e8e60d6d7ffc48e55aed1c.png";